<template>
  <div>
    <div class="container">
      <div class="columns is-centered">
        <div
          class="column is-12-mobile is-10-tablet is-10-desktop is-10-widescreen"
        >
          <div class="nav-top">
            <div class="nav-menu">
              <div class="nav-title">{{ appName }}</div>
              <div>
                <b-dropdown
                  style="margin-top:5px;margin-right: 15px;cursor:pointer"
                  :triggers="['hover']"
                  aria-role="list"
                >
                  <template #trigger>
                    <div :class="langIcon" />
                  </template>
                  <b-dropdown-item
                    aria-role="listitem"
                    :disabled="langIcon === 'svg-icon-th'"
                    @click="changeLocale('th')"
                  >
                    <div class="svg-icon-th" />
                    <span class="has-text-black m-l-5"> ไทย</span>
                  </b-dropdown-item>
                  <b-dropdown-item
                    aria-role="listitem"
                    :disabled="langIcon === 'svg-icon-la'"
                    @click="changeLocale('la')"
                  >
                    <div class="svg-icon-la" />
                    <span class="has-text-black m-l-5"> ລາວ</span>
                  </b-dropdown-item>
                  <b-dropdown-item
                    aria-role="listitem"
                    :disabled="langIcon === 'svg-icon-en'"
                    @click="changeLocale('en')"
                  >
                    <div class="svg-icon-en" />
                    <span class="has-text-black m-l-5"> Eng</span>
                  </b-dropdown-item>
                </b-dropdown>
                <a class="is-white" @click="handleLogout">
                  <i class="fas fa-sign-out-alt"></i>
                </a>
              </div>
            </div>
          </div>

          <router-view v-on:childinit="onChildInit" />
          <credit />

          <div class="nav-bottom">
            <ul>
              <li>
                <a href="/user/profile" :class="getActiveClass('profile')"
                  ><i class="far fa-user-circle"></i
                  >{{ $t('bottomMenuAuth.profile') }}</a
                >
              </li>
              <li>
                <a href="#" @click="modalCondition"
                  ><i class="fas fa-question-circle"></i
                  >{{ $t('bottomMenuAuth.condition') }}</a
                >
              </li>
              <li class="width120px"></li>
              <li>
                <a href="/user/statement" :class="getActiveClass('statement')"
                  ><i class="far fa-list-alt"></i
                  >{{ $t('bottomMenuAuth.statement') }}</a
                >
              </li>
              <li>
                <a href="/user/contact" :class="getActiveClass('contact')"
                  ><i class="fab fa-line"></i
                  >{{ $t('bottomMenuAuth.contact') }}</a
                >
              </li>
            </ul>
            <div class="big-menu">
              <a
                href="/user/home"
                class="big-menu"
                :class="getActiveClass('home')"
                ><i class="fas fa-home"></i
              ></a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <modal-condition
      v-if="modalConditionActive"
      :is-active="modalConditionActive"
      @closeModal="modalCondition"
    />
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import Credit from '@/components/Credit'
import ModalCondition from '@/views/user/components/modals/Condition'
import { getLocale, setCookieI18n, setLocale } from '@/utils/locale'
export default {
  name: 'BottomMenu',
  components: {
    Credit,
    ModalCondition
  },
  data() {
    return {
      appName: process.env.VUE_APP_NAME,
      page: '',
      modalConditionActive: false,
      langIcon: null
    }
  },
  mounted() {
    this.setLangIcon()
  },
  methods: {
    ...mapActions('auth', ['logout']),

    onChildInit(value) {
      this.page = value
    },
    getActiveClass(property) {
      return this.page === property ? 'active' : ''
    },
    handleLogout() {
      let loading = this.$loading.show()
      setTimeout(async () => {
        this.logout()
        loading.hide()
      }, 200)
    },
    modalCondition() {
      this.modalConditionActive = !this.modalConditionActive
      this.disabledBodyScroll(this.modalConditionActive)
    },
    disabledBodyScroll(isModalShow) {
      if (isModalShow) document.documentElement.style.overflow = 'hidden'
      else document.documentElement.style.overflow = 'auto'
    },
    setLangIcon() {
      const lang = getLocale()
      if (lang === 'th') {
        this.langIcon = 'svg-icon-th'
      } else if (lang === 'la') {
        this.langIcon = 'svg-icon-la'
      } else if (lang === 'en') {
        this.langIcon = 'svg-icon-en'
      }
    },
    changeLocale(lang) {
      setLocale(lang)
      setCookieI18n(lang.toUpperCase())
      this.setLangIcon()
      this.$i18n.locale = lang
    }
  }
}
</script>

<style scoped lang="scss">
.big-menu {
  position: fixed;
  left: 50%;
  text-align: center;
  width: 120px;
  margin-left: -65px;
  bottom: 0;
  // background-color: lighten($primary, 10);
  @if variable-exists(nav-bottom-background) {
    background: $nav-bottom-background;
    color: $nav-bottom-text-color !important;
  } @else if variable-exists(no-gradient-button) {
    background: linear-gradient(
      to bottom,
      $no-gradient-button,
      $no-gradient-button
    );
  } @else {
    background-image: linear-gradient(
      to right,
      $light-primary 0%,
      lighten($color: $light-primary, $amount: 20) 10%,
      $primary 55%,
      darken($color: $primary, $amount: 10) 65%,
      $light-primary 80%,
      lighten($color: $light-primary, $amount: 15) 100%
    );
  }

  height: 75px;
  line-height: 75px;
  font-size: 2.5rem;
  color: white;
  border-top-left-radius: 80px;
  border-top-right-radius: 80px;
  border-bottom: 0;

  &.active {
    background-color: $primary;
    color: white;
  }

  &:hover {
    // background-color: $light-primary;
    // font-size: 2.8rem;
    color: white;
  }
}

.width120px {
  width: 120px;
}

.nav-title {
  color: white;
  font-size: 20px;
  font-weight: 700;
}
a.is-white {
  color: white;
  font-size: 25px;
}

::v-deep .dropdown-content {
  width: 40%;
}
@media (max-width: 1024px) {
  ::v-deep .dropdown-content {
    width: 100%;
  }
}

::v-deep .dropdown-trigger {
  padding: 1px 4px;
  border: 1px solid #eae9e9;
  border-radius: 8px;
}
.svg-icon-th,
.svg-icon-la,
.svg-icon-en {
  width: 1.5em;
  height: 1.5em;
  background-size: cover;
  float: left;
}
.svg-icon-th {
  background-image: url(~@/assets/logo/th-lang.svg);
}
.svg-icon-la {
  background-image: url(~@/assets/logo/la-lang.svg);
}
.svg-icon-en {
  background-image: url(~@/assets/logo/en-lang.svg);
}
</style>
